import { returnUMTypeLabel } from "../../../../../lib/labels";
import { frontendOptions, umPolicyStatusOptionsPayerTypes } from "../../../../../lib/systemData";
import RadioField from "../../../../common/interactive/RadioField";
import IconBox from "../../../../iconboxes/IconBox";

export default function UMDrawerSection({classes, drawerData = {}, goToCaseTabHandler}) {
    const row = drawerData ?? {}
    const mpPipUm = Array.isArray(row.mp_pip_um) ? row.mp_pip_um : []
    const primaryUm = mpPipUm.find((r) => r.is_um_primary_insurance) || null
    const mpPipUmCount = row.mp_pip_um_count ?? mpPipUm.length

    return <div className={classes.block}>
        <div className={classes.block_header}>
            <h3>UM Insurance</h3>
            {mpPipUmCount >= 2 && <div className={classes.totals}>{mpPipUmCount}</div>}
            <button onClick={goToCaseTabHandler.bind(this, 3)}><i className='ti ti ti-arrow-up-right'></i></button>
        </div>
        <div className={classes.block_body}>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Carrier</div>
                <div className={classes.value}>{primaryUm?.insurance_carrier?.name}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Status</div>
                <div className={classes.value}>
                    {umPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryUm?.um_status)?.label}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>UM Adjuster</div>
                <div className={classes.value}>
                    {primaryUm?.um_adjuster && <>
                        <div>{primaryUm.um_adjuster.first_name} {primaryUm.um_adjuster.last_name}</div>
                        {primaryUm.um_adjuster.contact_information && primaryUm.um_adjuster.contact_information.phone && <IconBox type={'phone'} link={primaryUm.um_adjuster.contact_information.phone} workq={true}>
                            <i className="ti ti-phone"></i>
                        </IconBox>}
                    </>}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>UM Claim Number</div>
                <div className={classes.value}>{primaryUm?.um_claim_number}</div>
            </div>

            
            <div className={`${classes.block_body_row} ${classes.block_body_row_start}`}>
                <RadioField isDisable={true} fields={frontendOptions()?.umHeaderRadioFields} defaultChecked={primaryUm?.has_um} name={'has_um'} identifier={{type: 'case_mp_pip_um', field: 'has_um', type_id: primaryUm?.id, folder: 'mp_pip_um'}}/>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>UM Type</div>
                <div className={classes.value}>{returnUMTypeLabel(primaryUm?.um_type)}</div>
            </div>
            
        </div>
    </div>
}
